import React from "react";
import { Block } from "@randajan/jet-react/dom/block";
import { Caption } from "@randajan/jet-react/dom/caption";
import { Box, Button, Chip, Paper, Stack, Typography } from "@mui/material";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";

import { formatProfileCredit } from "../profilePrivateTools";
import { Locale } from "../../../../assets/Locale";

import "./CreditsPanel.scss";

export const CreditsPanel = (props)=>{
    const { profile={} } = props;
    const balance = formatProfileCredit(profile.creditBalance);
    const say = Locale.use();

    return (
        <Block tagName="section" className="CreditsPanel wall -form">
        
            <div className="header">
                <Caption className="BlimpMuiPanel-title">{say("profileCreditsCaption")}</Caption>
                <Chip
                    className="BlimpMuiPanel-status isMuted"
                    icon={<LockOutlinedIcon />}
                    label={say("profileCreditsPreparing")}
                    variant="outlined"
                />
            </div>
            <Box className="BlimpMuiPanel-credit">

            </Box>
            {/* <Stack className="BlimpMuiPanel-actions isStacked">
                <Button
                    className="BlimpMuiPanel-actionPrimary"
                    disabled
                    endIcon={<ShoppingCartOutlinedIcon />}
                    variant="contained"
                >
                    {say("profileCreditsBuy")}
                </Button>
                <Button
                    className="BlimpMuiPanel-action"
                    disabled
                    startIcon={<ConfirmationNumberOutlinedIcon />}
                    variant="outlined"
                >
                    {say("profileCreditsRedeemVoucher")}
                </Button>
            </Stack> */}
        </Block>
    );
};
